import { BodySecondary, LabelStrong } from '@liveauctioneers/hammer-ui-core/text';
import * as React from 'react';
import styled from 'styled-components';

type Props = {
    expertise: string;
    id: number;
    imgSrc: string;
    name: string;
};

const Curators = ({ expertise, id, imgSrc, name }: Props) => (
    <StyledCurator key={id}>
        <StyledImageContainer>
            <StyledImage
                alt={name}
                height={80}
                src={imgSrc}
                width={80}
            />
        </StyledImageContainer>
        <StyledDetails>
            <LabelStrong>{name}</LabelStrong>
            <BodySecondary color="secondary">{expertise}</BodySecondary>
        </StyledDetails>
    </StyledCurator>
);

export default Curators;

const StyledCurator = styled.div`
    display: flex;
    flex-direction: row;
    margin: 0 25px 26px;
`;

const StyledImageContainer = styled.div`
    width: 80px;
    height: 80px;
    position: relative;
    border-radius: 50%;
    overflow: hidden;
    min-width: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const StyledImage = styled.img`
    max-height: 80px;
    max-width: 80px;
    content-fit: contain;
`;

const StyledDetails = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 24px;
`;
